// Shared color rotation for chart series (legend entries, line strokes,
// stack segments, pie slices). Lives in DreamerCharts so primitive chart
// components can consume it without importing upward into chat-feature
// modules.
export const CHART_SEGMENT_COLORS = [
  "var(--emerald-500)", // #00F5A3
  "var(--blue-500)", // #3366FF
  "var(--purple-400)", // #867CF8
  "var(--pink-500)", // #EE38D0
  "var(--turquoise-500)", // #35B0A5
  "var(--teal-500)", // #33BBFF
  "var(--orange-300)", // #FEC84B
  "#6759FF", // saturated purple, distinct from --purple-500 (#5F50FF)
  "var(--green-300)", // #67EBA4
  "#C46BFF",
  "#53CED5",
  "#C4C436",
  "#F3AC4F",
  "#779BC7",
  "#DF5F95"
];

// CSS color allowlist — only hex literals and chart-prefixed CSS variables.
// Reject the broader `var(--anything)` and named keywords (`transparent`,
// `currentColor`, `inherit`) because those would let a server-supplied color
// inherit unrelated UI styling or render slices invisible.
const CSS_COLOR_PATTERN = /^(#[0-9a-fA-F]{3,8}|var\(--charts-[\w-]+\))$/;

export const isSafeChartColor = (value: unknown): value is string =>
  typeof value === "string" && CSS_COLOR_PATTERN.test(value.trim());

export const safeChartColor = (
  value: string | undefined,
  fallback: string
): string => (value && isSafeChartColor(value) ? value : fallback);

// Caller-supplied `override` lands in inline style / SVG fill — gate it
// through the allowlist so a server-provided segment.color can't smuggle
// CSS values past the rendering layer. Palette entries are our own constants,
// so they pass too: a caller that colors segments before filtering them keeps
// those colors instead of having them reassigned by position.
export const segmentColorAt = (index: number, override?: string): string => {
  if (
    override &&
    (isSafeChartColor(override) || CHART_SEGMENT_COLORS.includes(override))
  ) {
    return override;
  }
  return CHART_SEGMENT_COLORS[index % CHART_SEGMENT_COLORS.length];
};
